(function() {
'use strict';

angular
    .module('TR')
    .directive('eventTracker', eventTracker);

function eventTracker(analytics, $parse) {
    return {
        restrict: 'A',
        link: _linker
    };

    function _linker(scope, elem, attr) {
        let label = null;
        const category = attr.eventCategory;
        const type = attr.eventType;

        function _fireEvent() {
            const eventData = {
                label,
                category,
                value: 1
            };
            if (attr.eventAction) {
                eventData.action = attr.eventAction;
            }
            analytics.trackEvent(eventData);
        }

        function _destroyHandlers(events) {
            scope.$on('destroy', function() {
                elem.off(events);
            });
        }

        if (type !== 'textbox') {
            elem.on('click', function(e) {
                // only register left clicks
                if (e && e.button !== 0) {
                    return;
                }
                const attrLabel = $parse(attr.eventLabel)(scope);
                const attrTag = attr.eventTag ? `${attr.eventTag}: ` : '';
                label = attrLabel ? (`${attrTag}${attrLabel}`) : attr.eventTag;
                _fireEvent();
            });

            _destroyHandlers('click');
        } else {
            elem.on('keypress keydown', _.debounce(function() {
                label = $parse(attr.eventLabel)(scope);
                _fireEvent();
            }, 1500));

            _destroyHandlers('keypress keydown');
        }
    }
}
})();
